/* eslint-disable no-new */
// import VConsole from 'vconsole';
import Vue from 'vue';
import VueRx from 'vue-rx';
import liff from '@line/liff';
import axios from 'axios';
import BootstrapVue from 'bootstrap-vue';
import { isMobile } from 'mobile-device-detect';
import VueNotifyMessage from '@telexpress/vue-notify-message';
import App from './App.vue';
import router from './route/router';
import store from './store';
import i18n from './locales/i18n';
import filter from './filters/filter';
import Loader from './plugins/loader/loader';
import routeAuthentication from './apps/route-authentication';

import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'animate.css/animate.min.css';
import '@/assets/css/te-cutsom.min.css';
import '@/assets/css/te-mcf.min.css';
import '@/assets/css/te-customize-color.css';

// 載入所有 @/assets/svg 中的SVG檔案
const requireAll = (requireContext) => requireContext.keys().map(requireContext);
const req = require.context('@/assets/svg', true, /\.svg$/);
requireAll(req);

// 查詢參數
// const urlParams = new URLSearchParams(window.location.search);
//
// if (urlParams.get('console')) {
//   new VConsole();
// }
Vue.use(BootstrapVue);
Vue.use(VueRx);
Vue.use(Loader);
Vue.use(liff);

Vue.config.productionTip = false;
Vue.prototype.$http = axios;

store.state.isMobile = isMobile;

if (isMobile) {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  window.addEventListener('resize', () => {
    vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });
}

router.beforeEach(routeAuthentication);

router.beforeEach((to, from, next) => {
  // 從個人資訊到其他地方，資料重置
  if (from.name === 'personalInfo') {
    // 收合欄位
    store.commit('memberSource/setMemberSourceData', { id: 'updateAddress', value: false });
    store.commit('memberSource/setMemberSourceData', { id: 'updatePassword', value: false });
    // 清空答案
    store.commit('memberSource/setMemberSourceData', { id: 'answers', value: [] });
    store.commit('memberSource/setMemberSourceData', { id: 'customAnswers', value: [] });
    store.commit('memberSource/clearOriginalAnswerSnapshot');
  }
  next();
});

router.beforeEach((to, from, next) => {
  // 重置會員積點資料
  store.commit('delete', { name: 'memberBonus' });
  // 重置會員關鍵指標
  store.commit('delete', { name: 'memberIndicatior' });
  // 刷新badge
  store.dispatch('badge/refreshAllBadge');
  next();
});

Vue.use(VueNotifyMessage);

new Vue({
  router,
  store,
  i18n,
  filter,
  render: (h) => h(App),
}).$mount('#app');
